import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Content } from '@backstage/core-components';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 0,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60vh',
    padding: theme.spacing(4),
  },
  spinner: {
    marginBottom: theme.spacing(3),
    color: '#3182CE',
  },
  title: {
    fontSize: 18,
    fontWeight: 700,
    color: '#1A1A1A',
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    fontSize: 14,
    color: '#8E9299',
    textAlign: 'center',
  },
}));

export const HealthLoadingState: React.FC = () => {
  const classes = useStyles();

  return (
    <Content className={classes.root}>
      <Box className={classes.container}>
        <CircularProgress size={48} className={classes.spinner} />
        <Typography className={classes.title}>
          Gathering Health Data
        </Typography>
        <Typography className={classes.subtitle}>
          Analyzing code coverage metrics and quality trends...
        </Typography>
      </Box>
    </Content>
  );
};

export default HealthLoadingState;
